/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CodingQuestionEditorResetAnswerEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('CODING_QUESTION_EDITOR_RESET_ANSWER_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CodingQuestionEditorResetAnswerEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodingQuestionEditorResetAnswerEnabledSettingParser.decode(input).map(res => new CodingQuestionEditorResetAnswerEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return CodingQuestionEditorResetAnswerEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodingQuestionEditorResetAnswerEnabledSettingParser.encode(data);
    }
    static schema() {
        return CodingQuestionEditorResetAnswerEnabledSettingParser.schema();
    }
}
